import { common } from './common.ts'
import { clearURLParams, productStockManagement, tooltip, woocommerce, zoomInInputsOnSafariFix } from './integrations'
import { header } from './layout'
import {textWithIconAndTooltip} from './blocks'
import { select2 } from './libs'
import {
	bgLazy,
	blogListing,
	blogPostsCarousel,
	imagesGrid,
	productsCarousel,
	reviewsCarousel, singleProductTabsSidebar,
	slider
} from './sections'

header()
bgLazy()
slider()
reviewsCarousel()
blogPostsCarousel()
productsCarousel()
woocommerce()
common()
blogListing()
select2()
zoomInInputsOnSafariFix()
productStockManagement()
tooltip()
clearURLParams()
textWithIconAndTooltip()
singleProductTabsSidebar()
imagesGrid()
